<script>
import Modal from "@/components/_Shared/Modal";
export default {
  components: {
    Modal
  }
};
</script>

<template>
  <modal title="NOVO CARGO" subtitle="Cadastre um novo cargo" @close="$emit('close')">
    <template slot="body">
      <div class="form-group">
        <div class="input-group">
          <input id="name_role" type="text" placeholder=".">
          <label for="name_role">nome</label>
        </div>
      </div>
    </template>

    <template slot="footer">
      <button class="btn bg-purple-outline" @click="$emit('close')">fechar</button>
      <button class="btn bg-purple">cadastrar</button>
    </template>
  </modal>
</template>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Donamakers/NewRole.vue